import { useEffect } from "react";
import type { SelectValuesType } from "../types";
import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";
import { trackGTMEvent } from "lib/utils";
import { registerHubspotFormSubmitListener } from "lib/helpers/hubspot";

declare global {
  interface Window {
    hbspt: any;
  }
}

type FormIdsType = Record<SelectValuesType, string>;

const RoleTrackEventMap = new Map<SelectValuesType, string>([
  ["Operators", "Opertators Submit"],
  ["Founders and C-Suite", "Founders Csuite Submit"],
]);

const formIds: FormIdsType = {
  Operators: "ff7257b1-0971-4f99-9217-b19f27041ede",
  "Founders and C-Suite": "d592035e-5bd2-43af-b872-305fea66d607",
};

const ContactForm = ({ role }: { role: SelectValuesType | undefined }) => {
  const { track } = useMixpanelTracking();

  useEffect(() => {
    if (!role) return;

    const trackFormSubmit = async () => {
      const eventName = role ? RoleTrackEventMap.get(role) : undefined;
      if (!eventName) {
        return;
      }
      const clickLocation = window.location.href;

      await track(eventName, { clickLocation });
      trackGTMEvent({
        event: eventName,
        clickLocation,
      });
    };

    // Register listener immediately - it will wait for HubSpot messages
    const cleanup = registerHubspotFormSubmitListener(
      formIds[role],
      trackFormSubmit
    );

    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/v2.js";
    script.async = true;
    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "20037605",
          formId: formIds[role],
          target: `#hubspotForm`,
        });
      }
    };

    document.body.appendChild(script);

    return () => {
      cleanup(); // Remove event listener
      document.body.removeChild(script);
    };
  }, [role, track]);

  return <div id="hubspotForm" />;
};

export default ContactForm;
